var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-tooltip',{attrs:{"label":_vm.tooltipMessage,"type":"is-light","multilined":""}},[_c('b-tag',{class:_vm.type},[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }